

















































































import { Component, Prop, Watch, Mixins} from "vue-property-decorator";
import {UserProfile} from "@api/models/UserProfile";
import SearchUser from  './components/SearchUser.vue';
import {Meeting} from "@api/models/meetings/Meeting";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import { Debounce } from 'vue-debounce-decorator';
import SearchInput from "../common/search-input/SearchInput.vue";
import Participant from "./components/Participant.vue";
import TimeSelector from "./components/TimeSelector.vue";
import {MeetingRepository} from "@api/repositories/MeetingRepository";
import {DateTime} from "luxon";
import {doValidation} from "./helpers/Validation";
import {EventBus} from "@common/EventBus";
import {dateInOriginalOffset, incrementBasedOnRange, zoneNameByOffset} from "@common/dateTimeHelper";
import DatePick from 'vue-date-pick/src/vueDatePick.vue';
import {getVueDatePickLocale} from "@common/vueDatePick";
import DateLimitsMixin from "../../mixins/DateLimitsMixin";
import IsParticipantsLimited from "../../mixins/isParticipantsLimited";
import {Modal} from "@common/Modal";
import ControlWrapperBorderless from "../common/ControlWrapperBorderless.vue";
import BackButton from "@service/components/common/back-button/BackButton.vue";

import PeopleSelect from "@share/common/form/form-controls/select/people-select/PeopleSelect.vue"

@Component({
    name: 'MeetingForm',
    components: { PeopleSelect, BackButton, SearchUser, SearchInput, Participant, TimeSelector, DatePick, ControlWrapperBorderless }
})
export default class MeetingForm extends Mixins(DateLimitsMixin, IsParticipantsLimited) {
    @Prop() meeting: Meeting;
    @Prop({default: 'en'}) lang: string;
    @Prop() repositories: RepositoryFabric;
    @Prop() userId: number;
    @Prop({default: false}) isCreateForm: boolean;
    @Prop({required: true}) originalDate: DateTime;

    meetingRepository: MeetingRepository;
    datePickLocale: any = {};

    date = '';
    toTime = '';
    fromTime = '';
    errors: {[key: string]: string} = {};


    isInitialized = false;

    get eventId() {
        return this.$store.state.events.selected;
    }

    get timeRange() {
        return this.$store.getters['meetingsTimeRange'];
    }

    get isDeleted() {
        return this.meeting.isDeleted;
    }

    @Watch('meeting')
    onMeetingChange() {
        this.initMeetingData();
    }

    async mounted() {
        this.meetingRepository = this.repositories.get(RepositoryFabric.MEETING);
        this.datePickLocale = getVueDatePickLocale(this.lang);

        await this.initMeetingData();
        this.isInitialized = true;
    }

    async initMeetingData() {

        if (this.meeting.beginAt) {
            this.date = this.originalDate.toISODate();
            this.fromTime = this.meeting.beginAt.toFormat('HH:mm');
        }
        if (this.meeting.endAt) {
            this.toTime = this.meeting.endAt.toFormat('HH:mm');
        }
        (this.$refs['title'] as HTMLElement).focus();
        if (this.meeting.beginAt) {
            this.$nextTick(()  => {
                this.scrollCalendar();
            })
        }
    }

    @Watch('date')
    onDateChange() {
        this.onDateTimeChange();
        if (this.date) {
            this.$delete(this.errors, 'date');
        }
    }

    @Watch('fromTime')
    onFromTimeChange() {
        this.onDateTimeChange();
    }

    @Watch('toTime')
    onToTimeChange() {
        this.onDateTimeChange();
    }

    @Debounce(300)
    onDateTimeChange() {
        if (this.isInitialized) {
            this.setMeetingDates();
        }
    }

    @Debounce(500)
    onDescriptionInput() {
        this.$delete(this.errors, 'description');
    }

    setMeetingDates() {
        if (this.toTime) {
            const toTime = this.toTime || '00:00',
                increment = incrementBasedOnRange(this.toTime, this.timeRange),
                endAt = DateTime.fromISO(`${this.date}T${toTime}:00`).plus({days: increment});
            this.$set(this.meeting, 'endAt', endAt);
        }
        else {
            this.$set(this.meeting, 'endAt', null);
        }

        if (this.fromTime) {
            const fromTime = this.fromTime || '00:00',
                increment = incrementBasedOnRange(this.fromTime, this.timeRange),
                beginAt = DateTime.fromISO(`${this.date}T${fromTime}:00`).plus({days: increment});
            this.$set(this.meeting, 'beginAt', beginAt);
        }
        else {
            this.$set(this.meeting, 'beginAt', null);
        }
    }

    @Debounce(500)
    onTitleInput() {
        this.$delete(this.errors, 'title');
    }

    deleteParticipant(participant: UserProfile) {
        const index = this.meeting.participants.findIndex(item => item.userId == participant.userId);
        if (index > -1) {
            this.meeting.participants.splice(index, 1);
        }
    }

    timeChange(timeObject: {to: string; from: string}) {
        this.toTime = timeObject.to ?? null;
        this.fromTime = timeObject.from ?? null;

        if (this.toTime && this.fromTime) {
            this.$delete(this.errors, 'time');
        }
    }

    close(event: Event) {
        event.preventDefault();
        EventBus.$emit('modalClosed');
        this.$emit('closed');
    }

    async save() {
        const validationResult = await doValidation(this);
        if (validationResult) {
            this.$emit('beforeSave', this.meeting);
            try {
                const data = {
                    title: this.meeting.title || '',
                    description: this.meeting.description || '',
                    beginAt: this.meeting.beginAt?.toISO() as string,
                    endAt: this.meeting.endAt?.toISO() as string,
                    eventId: (this.meeting.eventId as string),
                    participantIds: this.meeting.participants
                        .map(item => item.userId as number)
                        .filter(userId => userId !== this.userId || this.meeting.id)
                };

                let newMeeting = null;
                if (this.meeting.id) {
                    newMeeting = await this.meetingRepository.save(this.meeting.id, data);
                }
                else {
                    newMeeting = await this.meetingRepository.create(data);
                }
                this.$emit('saved', newMeeting);
                EventBus.$emit('eventSaved', newMeeting);
            } catch (e) {
                this.$emit('saveError', e);
            }
        }
    }

    async remove() {
        if (this.meeting.id) {
            const modal = new Modal({
                title: this.$t('program.delete meeting').toString(),
                contentText: this.$t('program.delete subtext').toString(),
                buttons: [
                    {
                        text: this.$t('common.delete').toString(),
                        class: 'is-red',
                        returnValue: true
                    },
                    {
                        text: this.$t('common.cancel').toString(),
                        class: 'is-green is-outlined',
                        returnValue: false
                    }
                ]
            });

            const confirmResult = await modal.showConfirm();

            if (confirmResult === true) {
                try {
                    await this.meetingRepository.delete(this.meeting.id as string);
                    this.$store.dispatch('invites/removeMeeting', this.meeting.id);
                    EventBus.$emit('modalClosed');
                    this.$emit('deleted');
                }
                catch (e) {
                    this.$store.dispatch('reportError', e);
                }
            }
        }
    }

    scrollCalendar() {
        this.meeting.beginAt && this.$refs.calendar && (this.$refs.calendar as any).scrollToTime(this.meeting.beginAt.toFormat('HH:mm:00'));
    }

    onTimeSelectorHid() {
        if (this.meeting.beginAt && (!this.meeting.endAt || this.meeting.beginAt >= this.meeting.endAt)) {
            this.meeting.endAt = this.meeting.beginAt.plus({minutes: 15});
            this.toTime = this.meeting.endAt.toFormat('HH:mm');
        }
    }

    isDateDisabled(date: Date) {
        const newDate: DateTime = DateTime.fromObject({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: 12,
            minute: 0,
            zone: zoneNameByOffset(this.offset)
        }),
        today = dateInOriginalOffset(DateTime.local(), this.offset);
        return !(this.minLimit.startOf('day') <= newDate.startOf('day')
            && newDate.startOf('day') >= today.startOf('day'));
    }

    openAdd() {
        window.location.hash = 'add';
        this.$nextTick(() => {
            this.$clearAllBodyScrollLocks();
            const search = (this.$refs['search'] as any).$el as HTMLElement;
            if (search) {
                const input =  search.querySelector('input');
                input && input.focus();
            }
        })
    }
}
